import React from 'react'
import { IconClose } from 'components/Zui/Icon'
import { ScrollableDirective } from 'components/Zui'

function TermsToUse({ onClose }) {
    return (
        <>
            <div className="settings-wrapper">
                <div className="setting-header-wrapper">
                    <div className="setting-header-title">
                        <span>Terms of use ZEISS Surgical Cloud</span>
                    </div>
                    <div className="close-setting-wrapper" onClick={onClose}>
                        <div className="user-settings-close-button">
                            <IconClose size="m" className="close-setting-icon" />
                        </div>
                    </div>
                </div>
                <div className="legal-details-wrapper">
                    <ScrollableDirective style={{ maxHeight: '100%' }}>
                        <div className="legal-content-wrapper">
                            <div className="content-heading">
                                <span>Terms of use ZEISS Surgical Cloud</span>
                            </div>
                            <div className="legal-content-container">
                                <div className="content-sub-heading">
                                    <span>1. Scope</span>
                                </div>
                                <ol type="1">
                                    <li>
                                        These Terms govern the rights and obligations of the End
                                        User concerning the provision of ZEISS Surgical Cloud by the
                                        Service Provider to the End User. These Terms only apply to
                                        End Users who are natural persons.
                                    </li>
                                    <li>
                                        ZEISS Surgical Cloud is provided on an “as is” basis with a
                                        software-as-a-service approach. To ensure proper performance
                                        of Zeiss Surgical Cloud, the End User must meet the latest
                                        technical requirements. Zeiss Surgical Cloud and the
                                        technical requirements are described on the following
                                        website: [hyperlink to be inserted]. The Service Provider
                                        shall not be liable for any consequences to the extent they
                                        are caused by the End User’s failure to meet any such
                                        defined technical requirements. The Service Provider
                                        reserves the unilateral right to update Zeiss Surgical Cloud
                                        and the technical requirements on an ongoing basis and will
                                        make such updates available to End Users in an appropriate
                                        manner.
                                    </li>
                                    <li>
                                        To be able to use Zeiss Surgical Cloud, the End User must
                                        first be authorized by a customer. The End User has no
                                        ownership claim to performance vis-à-vis the Service
                                        Provider but can only derive any rights from the respective
                                        Customer (i.e., who has explicitly authorized the End User
                                        to use the Zeiss Surgical Cloud). An End User can be
                                        authorized to use Zeiss Surgical Cloud by multiple Customers
                                        simultaneously.
                                    </li>
                                    <li>
                                        If an End User in the EU shares End User Data with another
                                        End User residing in the US, the End User in the US will be
                                        able to access the shared End User Data and provide the End
                                        User in the EU with a second opinion. However, this is only
                                        possible via the European domain, meaning that an End User
                                        in the US will not be able to see his/her End User Data
                                        stored in the US or shares he/she has created via the US
                                        domain
                                    </li>
                                </ol>
                            </div>
                            <div className="legal-content-container">
                                <div className="content-sub-heading">
                                    <span>2. Definitions</span>
                                </div>
                                <div className="license-content" style={{ marginLeft: '25px' }}>
                                    <span>The following definitions apply</span>
                                </div>
                                <ol type="1">
                                    <li>
                                        “Customer” means the person or entity acquiring the paid
                                        subscription package from the Service Provider. Customers
                                        are entitled to authorize individual End Users to use Zeiss
                                        Surgical Cloud within the contractually agreed scope.
                                    </li>
                                    <li>
                                        "End User" means a natural person using Zeiss Surgical Cloud
                                        on the basis of this Agreement. For clarification: End Users
                                        can at the same time be ‘Customers’, provided that the
                                        conditions of Section 2.1 apply.
                                    </li>
                                    <li>
                                        "End User Data" means any content, materials, electronic
                                        data, or other information submitted by or on behalf of an
                                        End User to or through Zeiss Surgical Cloud.
                                    </li>
                                    <li>
                                        "End User Feedback" means any suggestions, questionnaires,
                                        reports, testimonials, enhancement requests,
                                        recommendations, or other feedback provided by an End User
                                        with regard to Zeiss Surgical Cloud.
                                    </li>
                                    <li>
                                        “Intellectual Property Rights" are any and all rights in and
                                        with respect to inventions, patents, copyrights, database
                                        rights, designs, know-how, trade secrets, moral rights,
                                        confidential and/or proprietary information, trade names,
                                        domain names, trade dress, logos, animated characters,
                                        trademarks, service marks, and other similar rights or
                                        interests in intellectual property, in any case, whether
                                        arising by registration or operation of law (and in the case
                                        of registered rights including all rights to apply and
                                        applications), wherever in the world arising, whenever
                                        arising and including all present and (where capable of
                                        present ownership) future rights.
                                    </li>
                                    <li>
                                        “Party” means the End Customer or the Service Provider,
                                        collectively referred to as the” Parties”
                                    </li>
                                    <li>“Service Provider” means Carl Zeiss MeditecAG.</li>
                                    <li>
                                        “Service Provider’s Affiliates” means Carl Zeiss MeditecAG,
                                        Göschwitzer Straße 51-52, 07745 Jena, Germany, and any
                                        entity controlled by Carl Zeiss MeditecAG where "control"
                                        will mean ownership, directly or indirectly, of at least
                                        fifty percent (50%) of the shares of an entity.
                                    </li>
                                    <li>
                                        “Terms” means the End User Terms for Zeiss Surgical Cloud.
                                    </li>
                                    <li>
                                        "Zeiss Surgical Cloud" means all combined Services provided
                                        by the Service Provider vis-à-vis an End Customer under
                                        these Terms
                                    </li>
                                    <li>
                                        “ZEISS-ID User Account” means the account required for the
                                        End User to log in to Zeiss Surgical Cloud.
                                    </li>
                                </ol>
                            </div>
                            <div className="legal-content-container">
                                <div className="content-sub-heading">
                                    <span>3. Proprietary Rights</span>
                                </div>
                                <ol type="1">
                                    <li>
                                        Subject to the limited rights expressly granted in these
                                        Terms, the Service Provider and Services Provider’s
                                        Affiliates reserve all their respective rights, title, and
                                        interest in and to Zeiss Surgical Cloud, including all
                                        related Intellectual Property Rights. No rights are granted
                                        to the End User hereunder other than as expressly set forth
                                        herein.
                                    </li>
                                    <li>
                                        Subject to the End User’s compliance with these Terms, the
                                        Service Provider grants the End User a non-exclusive,
                                        non-transferable, non-sublicensable right to access and use
                                        Zeiss Surgical Cloud solely for the Customer’s internal
                                        business purposes. As Zeiss Surgical Cloud is provided on a
                                        software-as-a-service basis, the End User shall not be
                                        provided with any hardware or any physical or digital copy
                                        of any Zeiss Surgical Cloud or any source code hereto other
                                        than as expressly set forth herein. The aforementioned grant
                                        of right only applies as long as the End User has been
                                        authorized for use by at least one Customer who has
                                        purchased a subscription package. The End User’s right to
                                        use Zeiss Surgical Cloud no longer exists as soon as the
                                        corresponding Customer (a) is no longer entitled to
                                        authorize the End User to use Zeiss Surgical Cloud and/or
                                        (b) has canceled the authorization of the End User. If an
                                        End User leaves a hospital and his/her access to the
                                        application gets removed (via ZEISS ID Management Portal),
                                        he/she will no longer have the access to shares created/sent
                                        by him/her (while he/she was assigned to an agreement), but
                                        this End User will have access to the Zeiss Surgical Cloud
                                        and the conversations he/she was invited to. In addition,
                                        this End User will have access only to the conversation
                                        view, but not to the patient view. This change is reflected
                                        on the platform by the fact that the status of this End User
                                        changes from “premium” to “freemium”
                                    </li>
                                    <li>
                                        The End User grants the Service Provider and its
                                        subcontractors a limited, personal, transferable,
                                        non-exclusive right to use End User Data for the sole
                                        purpose to and solely as required to perform Zeiss Surgical
                                        Cloud.
                                    </li>
                                    <li>
                                        The End User grants the Service Provider and the Services
                                        Provider’s Affiliates an exclusive, royalty-free, worldwide,
                                        transferable, sublicensable, irrevocable, perpetual license
                                        to use, analyze and incorporate into Zeiss Surgical Cloud
                                        any End User Feedback.
                                    </li>
                                    <li>
                                        Vis-à-vis Service Provider, the use of Zeiss Surgical Cloud
                                        will happen at the End User’s own operational risk. In
                                        particular, the Service Provider will have no operational
                                        responsibility for the End User’s medical evaluations,
                                        medical decisions, medical operations, or other medical
                                        activities. It is the End User’s responsibility vis-à-vis
                                        Service Provider to ensure, and the Service Provider will
                                        not assume any responsibility, that the End User’s use of
                                        Zeiss Surgical Cloud complies with applicable law.
                                    </li>
                                    <li>
                                        These Terms do not apply to third-party software, including
                                        so-called Free Software and Open-Source Software (FOSS).
                                        Such third-party software is subject to the applicable
                                        license terms of the respective copyright holder. The End
                                        Users agree that any warranty or liability of the Service
                                        Provider for such third-party software is expressly excluded
                                        unless otherwise agreed.
                                    </li>
                                </ol>
                            </div>
                            <div className="legal-content-container">
                                <div className="content-sub-heading">
                                    <span>4. Restrictions of Use</span>
                                </div>
                                <ol type="1">
                                    <li>
                                        The End User shall not (i) permit any third party to access
                                        Zeiss Surgical Cloud except as permitted in these Terms,
                                        (ii) create derivative works based on Zeiss Surgical Cloud,
                                        (iii) reverse engineer Zeiss Surgical Cloud, unless this is
                                        permitted by mandatory applicable laws, or (iv) access Zeiss
                                        Surgical Cloud in order to (a) build a competitive product
                                        or service, or (b) copy any features, functions or graphics
                                        of Zeiss Surgical Cloud.
                                    </li>
                                    <li>
                                        The End User shall (i) only use Zeiss Surgical Cloud in
                                        accordance with these Terms and applicable laws, (ii) be
                                        solely responsible vis-à-vis Service Provider for the
                                        accuracy, quality, integrity, and legality of End User Data
                                        and of the means by which it acquired End User Data; (iii)
                                        use commercially reasonable efforts to prevent unauthorized
                                        access to or use of Zeiss Surgical Cloud and End User Data,
                                        and notify the Service Provider without delay of any such
                                        unauthorized access or use; (iv) not interfere with or
                                        disrupt the integrity or performance of Zeiss Surgical Cloud
                                        or third-party data contained therein, and (v) not attempt
                                        to gain unauthorized access to Zeiss Surgical Cloud or their
                                        related systems or networks
                                    </li>
                                    <li>
                                        The End User acknowledges and agrees that the Service
                                        Provider does not monitor or control the content of the End
                                        User Data uploaded in or transmitted through Zeiss Surgical
                                        Cloud and that the Service Provider shall not be responsible
                                        for the content of any such communications or transmissions.
                                        The End User shall use Zeiss Surgical Cloud exclusively for
                                        authorized and legal purposes, consistent with all
                                        applicable laws. The End User agrees not to upload to Zeiss
                                        Surgical Cloud any content or data that (i) is libelous,
                                        defamatory, obscene, pornographic, abusive, harassing, or
                                        threatening; (ii) contains viruses, worms, time bombs,
                                        trojan horses or other harmful or malicious code, files,
                                        scripts, agents or programs; (iii) violates the rights of
                                        others, such as data which infringes on any Intellectual
                                        Property Rights or violates any right of privacy or
                                        publicity; or (iv) otherwise violates any applicable laws
                                        (including, without limitation, the laws and regulations
                                        governing unfair competition and the laws of profession).
                                        The Service Provider reserves the right to delete, move or
                                        edit any End User Data that it may determine, in its
                                        reasonable discretion, violates these Terms and/or
                                        applicable laws.
                                    </li>
                                    <li>
                                        If the End User violates any obligation under this Section4,
                                        the End User must give notice to the Service Provider
                                        without undue delay with a detailed description of the
                                        concrete violation. The Service Provider shall not be
                                        responsible for the consequences caused by such violations
                                        of the End User’s obligations.
                                    </li>
                                    <li>
                                        The End User shall (i) indemnify and hold harmless the
                                        Service Provider and Service Provider’s Affiliates from and
                                        against any and all third party claims finally awarded by a
                                        court of final jurisdiction or settled/acknowledged with the
                                        End User’s prior written approval, and (ii) defend such
                                        claims at the End User’s own cost, both in and out-of-court,
                                        to the extent, this is related to a claim of a third party
                                        alleging that End User Data, or the End User's use of Zeiss
                                        Surgical Cloud in violation of these Terms, infringes any
                                        third-party rights, in particular, but without limitation
                                        third-party Intellectual Property Rights, or violates
                                        applicable laws. The Service Provider will (a) give the End
                                        User notice of the claim, (b) give the End User sole control
                                        of the defense and settlement of the claim, and (c) provide
                                        the end-user with all reasonable assistance, at the End
                                        User's cost. The End User’s duty to indemnify shall not
                                        apply in case of circumstances due to which the End User can
                                        prove not to be responsible for the infringement.
                                    </li>
                                </ol>
                            </div>
                            <div className="legal-content-container">
                                <div className="content-sub-heading">
                                    <span>5. Registration of End Users</span>
                                </div>
                                <ol type="1">
                                    <li>
                                        The use of Zeiss Surgical Cloud requires a ZEISS ID Device
                                        Account. The ZEISS ID Device Account is subject to separate
                                        “Terms and Conditions of Use for ZEISS ID” which can be
                                        viewed via the following hyperlink Terms &#38; Conditions of
                                        Use for ZEISS ID.
                                    </li>
                                    <li>
                                        Registration for a ZEISS ID User Account is reserved for
                                        natural persons who are at least eighteen years of age. Each
                                        person may only register once. The ZEISS ID User Account is
                                        not transferable and may only be used by the registered
                                        person.
                                    </li>
                                    <li>
                                        The data requested to register for a ZEISS ID User Account
                                        must be entered completely and correctly. In particular, it
                                        is inadmissible to provide a false identity. If the data
                                        provided during the registration changes after registration,
                                        the End User is obliged to update the data without undue
                                        delay.
                                    </li>
                                    <li>
                                        The credentials for the End User‘s ZEISS ID User Account,
                                        particularly the password, shall not be made accessible by
                                        the End User to any other person. It is the End User’s
                                        responsibility to ensure that the End User‘s ZEISS ID User
                                        Account is not used by any other person. If the End User has
                                        reason to assume that a third party has gained or will gain
                                        knowledge of the End User‘s credentials, the End User shall
                                        inform the Service Provider immediately hereof. The End User
                                        shall be liable for any damage caused by the unauthorized
                                        use of the End User‘s ZEISS ID User Account by third parties
                                        unless the End User is not responsible for the unauthorized
                                        use of the End User’s ZEISS ID User Account.
                                    </li>
                                    <li>
                                        The Service Provider may revoke access to Zeiss Surgical
                                        Cloud for a particular ZEISS ID User Account if the Service
                                        Provider has a legitimate reason to assume that the usage of
                                        Zeiss Surgical Cloud under the respective ZEISS ID User
                                        Account has (i) a negative effect on the rights or
                                        legitimate interests of the Service Provider, the Service
                                        Provider’s Affiliates or third parties so that immediate
                                        action is necessary to avoid damage (ii) the respective
                                        ZEISS ID User Account is not used by the person to whom it
                                        is assigned or (iii) the suspension is required by law, a
                                        court decision, or a request from a governmental body. The
                                        Service Provider will limit the suspension to the period
                                        necessary for the elimination of the reason for the
                                        suspension. If possible, the Service Provider will inform
                                        the user prior to any intended suspension of her/his ZEISS
                                        ID User Account, via notification to the e-mail-address the
                                        respective ZEISS ID User Account is linked to. In any case,
                                        the Service Provider will notify the user immediately after
                                        suspension, via notification to the e-mail-address the
                                        respective ZEISS ID User Account is linked to. The
                                        suspension right is in addition to, and restoration is
                                        without prejudice to all other rights and remedies the
                                        Service Provider may have.
                                    </li>
                                    <li>
                                        For clarification, when for registering a ZEISS ID User
                                        Account, the Service Provider and the relevant user
                                        (irrespective of whether this is the Customer, the End User
                                        or a third party) enter into a separate agreement on the
                                        creation and use of the ZEISS ID User Account subject to the
                                        “Terms and Conditions of Use for ZEISS ID”.
                                    </li>
                                </ol>
                            </div>
                            <div className="legal-content-container">
                                <div className="content-sub-heading">
                                    <span>6. Data Protection</span>
                                </div>
                                <ol type="1">
                                    <li>
                                        The End User is responsible vis-à-vis Service Provider to
                                        comply with all data protection laws, regulations,
                                        requirements, or the like that apply to the End User’s use
                                        of Zeiss Surgical Cloud.
                                    </li>
                                    <li>
                                        The End User is particularly aware that the access to or the
                                        disclosure of personal data from/to third countries, i.e.
                                        countries outside the European Economic Area (EEA), can be
                                        subject to the provisions on the transfer of personal data
                                        to third countries set forth in Art. 44 et seqq. GDPR and
                                        that the End User must not access to or disclose personal
                                        data from/to third countries if the End User has not ensured
                                        compliance with Art.44 et seqq. GDPR, if applicable.
                                    </li>
                                    <li>
                                        The End User shall use Zeiss Surgical Cloud only in
                                        compliance with all provisions on professional secrecy to
                                        which the End User, Customer and/or their legal
                                        representatives, employees, or vicarious agents are subject.
                                        The End User is particularly solely responsible to obtain
                                        the affected patient’s valid consent for the disclosure of
                                        the patient’s data to third parties in connection with the
                                        data sharing feature of Zeiss Surgical Cloud.
                                    </li>
                                    <li>
                                        Furthermore, it is the End User’s sole responsibility
                                        vis-à-vis Service Provider to use the sharing feature of
                                        Zeiss Surgical Cloud only to share information with persons
                                        whose identity and contact details (e.g., email address) the
                                        End User verified. Particularly, the Service Provider does
                                        not check or verify the identity, or the contact details of
                                        the persons registered for a ZEISS ID User Account.
                                    </li>
                                    <li>
                                        For clarification, the Service Provider does not process any
                                        personal data of patients on behalf of the End User. The
                                        Service Provider processes such data only on behalf of a
                                        customer who may authorize the End User to view, share or
                                        otherwise process the relevant data and who may revoke such
                                        authorization at its discretion at any time, without the
                                        Service Provider having any influence on it.
                                    </li>
                                </ol>
                            </div>
                            <div className="legal-content-container">
                                <div className="content-sub-heading">
                                    <span>7. No Warranties</span>
                                </div>
                                <ol type="1">
                                    <li>
                                        The End User must give notice of every defect to the Service
                                        Provider without delay and with a detailed description of
                                        the defect.
                                    </li>
                                    <li>
                                        The End User agrees to cooperate with the Service Provider
                                        by providing any required information and documentation and
                                        all other assistance that might be reasonable in order for
                                        the Service Provider to remedy the respective defect.
                                    </li>
                                    <li>
                                        Except for the express obligations set forth in these Terms,
                                        the Service Provider assumes no obligations to the End User,
                                        and any statements about Zeiss Surgical Cloud and their
                                        respective functionality in any communication with the End
                                        User are for information purposes only and do not constitute
                                        obligations of the Service Provider or the Service
                                        Provider’s Affiliates. None of the Service Provider’s
                                        obligations under these Terms shall be deemed to constitute
                                        a guaranteed quality or other guarantees. Furthermore, the
                                        Service Provider assumes no warranty or liability that Zeiss
                                        Surgical Cloud meet the expectations of the End User with
                                        regard to individual requirements and purposes of the End
                                        User unless explicitly agreed between the Parties in these
                                        Terms
                                    </li>
                                </ol>
                            </div>
                            <div className="legal-content-container">
                                <div className="content-sub-heading">
                                    <span>8. Limited Liability</span>
                                </div>
                                <ol type="1">
                                    <li>
                                        The Service Provider is liable for damages: (i) to the
                                        extent that liability cannot be limited or excluded
                                        according to applicable law, in particular, applicable
                                        product liability law; (ii) caused by intent or gross
                                        negligence; and (iii) in cases of damage to life, body or
                                        health caused by ordinary negligence.
                                    </li>
                                    <li>
                                        Without prejudice to Section9.1, (a) the Service Provider is
                                        not liable for damages or frustrated expenses caused by
                                        ordinary negligence, except in cases of a violation of
                                        material contractual obligations in a manner jeopardizing
                                        the purpose of these Terms or of contractual obligations the
                                        fulfillment of which is indispensable for the proper and due
                                        performance of these Terms and which the End User will and
                                        may usually rely on (Kardinalpflichten), (b) the Service
                                        Provider’s liability for all claims arising out of or in
                                        connection with these Terms shall be limited to a total of
                                        EUR 10.000.
                                    </li>

                                    <li>
                                        Except for claims under Section9.1, any rights, claims and
                                        remedies for damages and indemnities arising out of or
                                        related to these Terms, whether in contract, tort or
                                        otherwise, shall expire no later than two (2) years.
                                    </li>
                                    <li>
                                        The Service Provider’s limitations of liability under these
                                        Terms shall apply to the benefit of any directors,
                                        employees, agents, subcontractors, business partners, and
                                        any persons used by the Service Provider in performing any
                                        obligations under these Terms.
                                    </li>
                                    <li>
                                        Without prejudice to Section9.4 Service Provider’s
                                        limitations of liability under these Terms shall also apply
                                        to the benefit of the Service Provider’s Affiliates with
                                        regard to the End User’s claims out or in connection with
                                        the End User’s use of ZEISS Cloud Services.
                                    </li>
                                </ol>
                            </div>
                            <div className="legal-content-container">
                                <div className="content-sub-heading">
                                    <span>9. General Provisions</span>
                                </div>
                                <ol type="1">
                                    <li>
                                        The End User is responsible vis-à-vis Service Provider for
                                        ensuring that it may use and access Zeiss Surgical Cloud as
                                        provided by the Service Provider in compliance with any
                                        applicable import or export laws. The End User shall not
                                        import or (re-)export Zeiss Surgical Cloud in violation of
                                        any national or international law, in particular any export
                                        or import regulation of the European Union or the United
                                        States of America. Without limiting the foregoing, (i) each
                                        Party represents that it is not named on any government list
                                        of persons or entities prohibited from receiving exports,
                                        and (ii) the End User shall access or use Zeiss Surgical
                                        Cloud in violation of any export embargo, prohibition, or
                                        restriction.
                                    </li>
                                    <li>
                                        Should any provisions of these Terms be or become
                                        ineffective, invalid, or unenforceable, this shall not
                                        affect the validity of the rest of the provisions. The same
                                        applies in the event that the Parties subsequently discover
                                        that these Terms contain omissions.
                                    </li>
                                    <li>
                                        The End User may not assign any of its rights or obligations
                                        out of or in connection with these Terms without the prior
                                        written consent of the Service Provider.
                                    </li>
                                    <li>
                                        These Terms, and any disputes arising out of or related
                                        hereto, shall be governed exclusively by the laws of the
                                        Federal Republic of Germany, without regard to its conflicts
                                        of laws rules. The U.N. Convention on the International Sale
                                        of Goods (CISG) of April 11, 1980 as well as all related
                                        agreements shall not apply.
                                    </li>
                                    <li>
                                        For all disputes arising out of or in connection with these
                                        Terms, the courts of München (Landgericht München I) shall
                                        have exclusive jurisdiction.
                                    </li>
                                </ol>
                            </div>
                            <div className="copyright-text">
                                Copyright © Carl Zeiss Meditec AG, 2022. Alle Rechte vorbehalten.
                            </div>
                        </div>
                    </ScrollableDirective>
                </div>
            </div>
        </>
    )
}
export default TermsToUse
